import { ActionReducerMap } from '@ngrx/store';
import { BranchSettingsStates } from '../states';
import * as fromBranchSettingsReducers from './branch-settings.reducers';

export const branchSettingsReducers: ActionReducerMap<BranchSettingsStates> = {
  branchSettings: fromBranchSettingsReducers.branchSettingsReducer
};
